var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "31",
      "height": "31",
      "viewBox": "0 0 31 31",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "clip-path": "url(#weeklyMenu_svg__clip0_919_3955)",
      "fill": "#F1D5AA"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.453 12.768v12.427a1.212 1.212 0 002.422 0V12.768A1.935 1.935 0 005.328 10.9V5.086a.484.484 0 10-.969 0V8.96h-.484V5.086a.484.484 0 10-.969 0V8.96h-.484V5.086a.484.484 0 10-.969 0V8.96H.97V5.086a.484.484 0 10-.969 0v5.813c0 .9.62 1.653 1.453 1.87zm1.453 12.427a.243.243 0 01-.242.242.243.243 0 01-.242-.242V12.837h.484v12.358zM.97 9.93h3.39v.97a.97.97 0 01-.968.968H1.937A.97.97 0 01.97 10.9v-.97zM27.608 4.596a.484.484 0 00-.484.484l.002.007v20.107a1.212 1.212 0 002.421 0v-8.48h.97A.484.484 0 0031 16.23V7.987a3.396 3.396 0 00-3.392-3.391zm.97 20.598a.243.243 0 01-.242.242.243.243 0 01-.242-.242v-8.48h.485v8.48zm1.454-9.448h-1.938V5.614a2.427 2.427 0 011.938 2.373v7.759z"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.742 4.596c-6.009 0-10.898 4.889-10.898 10.898 0 6.01 4.889 10.899 10.898 10.899 6.01 0 10.899-4.89 10.899-10.899 0-6.009-4.89-10.898-10.899-10.898zm0 20.828c-5.475 0-9.93-4.454-9.93-9.93 0-5.475 4.455-9.93 9.93-9.93 5.476 0 9.93 4.455 9.93 9.93 0 5.476-4.454 9.93-9.93 9.93z"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.742 7.986c-4.14 0-7.508 3.368-7.508 7.508 0 4.14 3.368 7.508 7.508 7.508 4.14 0 7.508-3.368 7.508-7.508 0-4.14-3.368-7.508-7.508-7.508zm0 14.047a6.546 6.546 0 01-6.539-6.539 6.546 6.546 0 016.54-6.539 6.546 6.546 0 016.538 6.54 6.546 6.546 0 01-6.539 6.538z"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "weeklyMenu_svg__clip0_919_3955"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0h31v31H0z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }